// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { PositionFormatter } from '@shared/commons/cache/Formatters/PositionFormatter';
import { Resources } from '@shared/localizations/Resources';
import { WDSettingsUtils } from '../UtilsClasses/WDGeneralSettingsUtils';
import { BaseItem, ColumnData } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { PositionItem } from './PositionItem';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { ThemeManager } from '../misc/ThemeManager';
export class ClosePositionsMutuallyItem extends BaseItem {
    constructor(pos, sessionSettings /*, isNetQty */) {
        super(sessionSettings);
        if (isNullOrUndefined(pos))
            return;
        this.position = pos;
        this.NetQty = false; //! !isNetQty;   // #92796 пункт 4 a. ii. доки: https://docs.google.com/document/d/1y4W7_QHbI4siuOD4OwrBucXWxQdbbqJoiw8bfEKvDhI/edit
    }
    getQuickTableCellForeground(column) {
        if (column === QUANTITY_COLUMN) {
            return ThemeManager.colors.tableQuantityForeground;
        }
        else if (column === SIDE_COLUMN && !isNullOrUndefined(this.position)) {
            if (PositionFormatter.Operation(this.position) === OperationType.Buy) {
                return ThemeManager.colors.buyColor;
            }
            else {
                return ThemeManager.colors.sellColor;
            }
        }
        else {
            return super.getQuickTableCellForeground(column);
        }
    }
    ColumnCount() {
        return ClosePositionsMutuallyItem.columnsParams.length;
    }
    getColumnData(column) {
        const resultData = new ColumnData();
        const value = (resultData.Value = this.getColumnValue(column));
        const pos = this.position;
        if (pos) {
            switch (column) {
                // case POSITION_ID_COLUMN:
                case SIDE_COLUMN:
                    resultData.FormattedValue = PositionFormatter.OperationStr(pos);
                    break;
                case QUANTITY_COLUMN:
                    resultData.FormattedValue = DataCache.formatVolume(pos.Instrument, Math.abs(value), WDSettingsUtils.displayAmountInLots(), pos.ProductType, pos.Account);
                    break;
                default:
                    resultData.FormattedValue = value ? value.toString() : '';
                    break;
            }
        }
        return resultData;
    }
    getColumnValue(column) {
        const pos = this.position;
        if (!pos)
            return null;
        switch (column) {
            case POSITION_ID_COLUMN:
                return PositionFormatter.PositionId(pos);
            case SIDE_COLUMN:
                return PositionFormatter.Operation(pos);
            case QUANTITY_COLUMN: {
                const sign = PositionItem.GetPositionSign(pos, this.NetQty);
                return PositionItem.GetPositionAmount(pos) * sign;
            }
            default:
                return null;
        }
    }
    GetColumnParams(column) {
        const result = ClosePositionsMutuallyItem.columnsParams[column];
        result.Hidden = result.DefaultHidden || Resources.isHidden(result.HeaderKey);
        result.MenuIndex = this.GetMenuIndex(result.HeaderKey);
        return result;
    }
    GetMenuIndex(headerKey) {
        if (ClosePositionsMutuallyItem.ListMenuIndex.Contains(headerKey)) {
            return ClosePositionsMutuallyItem.ListMenuIndex.indexOf(headerKey);
        }
        else {
            return 1000;
        }
    }
}
/// <summary>
/// Здесь хранятся настройки колонок (один экземпляр на класс)
/// </summary>
ClosePositionsMutuallyItem.columnsParams = [
    new ColumnParams('panel.ClosePositionsMutually.PositionID', 75, QTAlignment.Right, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.ClosePositionsMutually.Side', 75, QTAlignment.Right, TableTotalsVisibility.None, true, false),
    new ColumnParams('panel.ClosePositionsMutually.Quantity', 75, QTAlignment.Right, TableTotalsVisibility.None, true, false)
];
ClosePositionsMutuallyItem.ListMenuIndex = [
    'panel.ClosePositionsMutually.PositionID',
    'panel.ClosePositionsMutually.Side',
    'panel.ClosePositionsMutually.Quantity'
];
const POSITION_ID_COLUMN = 0;
const SIDE_COLUMN = 1;
const QUANTITY_COLUMN = 2;
